import memberRequest from './memberRequest';
import { ORDER_API } from '../constants/endpoints';

/**
 * 下單服務 — ORDER_API，身份由 Token 解析，不帶 memberId。
 */
export const orderApi = {
  /** 交割合約商品 */
  listFuturesProducts: () => memberRequest.get(`${ORDER_API}/futures/products`),

  /** 依玩法列出父商品（行情頁） */
  listParentProducts: (playType) =>
    memberRequest.get(`${ORDER_API}/products/parents`, { params: { playType } }),

  /** 熱門商品（交割父商品，sort 最小前 N 筆） */
  listHotProducts: (limit = 4) =>
    memberRequest.get(`${ORDER_API}/products/hot`, { params: { limit } }),

  getCurrentFuturesRound: (productId) =>
    memberRequest.get(`${ORDER_API}/futures/rounds/current`, {
      params: { productId },
    }),

  /**
   * 交割展示 K 線（market 歷史 + overlay 合併）。
   * 傳 startTime + endTime 走歷史區間；僅傳 limit 走最新 N 根。
   */
  getFuturesChart: (productId, params = {}) =>
    memberRequest.get(`${ORDER_API}/futures/chart`, {
      params: { productId, ...params },
    }),

  listAvailableFuturesRounds: (productId, params = {}) =>
    memberRequest.get(`${ORDER_API}/futures/rounds/available`, {
      params: { productId, pageNo: 1, pageSize: 9999, ...params },
    }),

  placeFuturesOrder: (data) =>
    memberRequest.post(`${ORDER_API}/futures/order`, data),

  listFuturesOrders: (params) =>
    memberRequest.get(`${ORDER_API}/futures/order`, { params }),

  /** 撤銷尚未結算的交割訂單（身份由 Token 解析，body 僅帶 id） */
  cancelFuturesOrder: (data) =>
    memberRequest.post(`${ORDER_API}/futures/order/cancel`, data),

  /** 可跟單配置列表（局未結算且開放中） */
  listFollowOrders: (params) =>
    memberRequest.get(`${ORDER_API}/futures/order/follow-orders`, { params }),

  /** 限時交易商品（sort 升序，首筆為 sort 最小） */
  listTimedProducts: () => memberRequest.get(`${ORDER_API}/timed/products`),

  /** 永續合約商品 */
  listPerpetualProducts: () => memberRequest.get(`${ORDER_API}/perpetual/products`),

  placePerpetualOrder: (data) => memberRequest.post(`${ORDER_API}/perpetual/order`, data),

  closePerpetualOrder: (orderSerialId) =>
    memberRequest.post(`${ORDER_API}/perpetual/order/${encodeURIComponent(orderSerialId)}/close`),

  cancelPerpetualOrder: (orderSerialId) =>
    memberRequest.post(`${ORDER_API}/perpetual/order/${encodeURIComponent(orderSerialId)}/cancel`),

  updatePerpetualOrder: (data) =>
    memberRequest.post(`${ORDER_API}/perpetual/order/update`, data),

  listPerpetualOrders: (params) =>
    memberRequest.get(`${ORDER_API}/perpetual/order`, { params }),

  placeTimedOrder: (data) => memberRequest.post(`${ORDER_API}/timed/order`, data),

  listTimedOrders: (params) =>
    memberRequest.get(`${ORDER_API}/timed/order`, { params }),

  /** @deprecated 請改用 getCurrentFuturesRound */
  getCurrentRound: (productId) =>
    memberRequest.get(`${ORDER_API}/futures/rounds/current`, {
      params: { productId },
    }),
};
